<template lang="html">
<content-div v-if="onload">

  <div class="contArea">

    <div class="titWrap" style="
      margin-top: 20px;
      margin-bottom: 20px;
    ">
      <h3 class="conTit1">BMW ServiceCare+ 서비스 상세</h3>
    </div>
    
    <div class="infoTable02">
      <ul>
        <li><em>모델</em><span>{{subsc.vehicle.vehicle_cat.title}}</span></li>
        <li><em>차량번호</em><span>{{subsc.vehicle.num_reg}}</span></li>
        <li><em>멤버십명</em><span>BMW ServiceCare+<br>{{subsc.pkg.title}}</span></li>
        <li>
          <em>서비스 기간</em>
          <span v-if="subsc.state == SUBSC_STATE.ENABLE_REQ">
            가입신청중
            <!-- <br>{{getDateFormat(subsc.created_at)}} -->
          </span>
          <span v-else>
            {{getDateFormat(subsc.date_start)}}<br>~ {{getDateFormat(subsc.date_stop)}}
          </span>
        </li>
        <li class="line02">
          <em>소비자가</em>
          <span>{{subsc.payments.price_pkg | currency}}원</span>
        </li>
        <li v-if="subsc.payments.promo.price">
          <em>프로모션가</em>
          <span v-if="subsc.payments.promo_code.overlap==OVERLAP_DISABLE">VIP 할인코드 중복불가</span>
          <span v-else class="fCol2">{{promoPrice | currency}}원</span>
        </li>
        <!--VIP 할인코드 적용된 경우 -->
        <li v-if="promoCodePrice">
          <em>VIP 할인코드</em>
          <span class="fCol2">-{{promoCodePrice | currency}}원</span>
        </li>
        <li class="line02">
          <em class="WBkeepAll">⁠총 결제금액(VAT포함)</em>
          <span class="fCol1">{{subsc.payments.price_payment | currency}}원</span>
        </li>
      </ul>
    </div>

    <div class="titWrap">
      <h3 class="conTit1">
        <span v-if="[
          SUBSC_STATE.DISABLE_REVOKE_REFUND,
          SUBSC_STATE.DISABLE_REVOKE_REFUND_CONFIRM
        ].includes(subsc.state)">
          환불
        </span>
        결제정보
      </h3>
    </div>

    <div class="infoTable02">

      <ul>
        <li><em>주문번호</em><span>{{(subsc.recordPayments && subsc.recordPayments.length > 0) ? subsc.recordPayments[0].id : ''}}</span></li>
        <li><em>결제일</em><span>{{getDateFormat(subsc.payments.date)}}</span></li>

        <li v-if="![
          SUBSC_STATE.DISABLE_REVOKE_REFUND,
          SUBSC_STATE.DISABLE_REVOKE_REFUND_CONFIRM
        ].includes(subsc.state)">
          <em>신용카드</em><span>{{subsc.payments.price_payment | currency}}원</span>
        </li>
  
        
        <template v-else>
          <li><em>환불일</em><span>{{getDateFormat(subsc.date_state)}}</span></li>
          <li class="line02"><em>소비자가</em><span>{{String(subsc.payments.price_pkg) | currency}}원</span></li>
          <li><em class="WBkeepAll">프로모션 할인금액</em><span>{{String(subsc.payments.price_pkg - subsc.payments.promo.price) | currency}}원</span></li>
          <li><em class="WBkeepAll">VIP할인코드 할인금액</em><span>{{String(subsc.payments.promo_code.price) | currency}}원</span></li>
          
          <template v-if="(typeof subsc.payments.refund_data != 'undefined' && !subsc.payments.refund_data.insurance_prod_use)">
            <li><em>해지 위약금</em><span>{{String(subsc.payments.refund_data.penalty) | currency}}원</span></li>
            <!-- <li><em>일수 차감금액</em><span>{{String(subsc.payments.refund_data.use.price) | currency}}원</span></li> -->
            <li><em>실제정비금액</em><span>{{String( subsc.payments.refund_data.care) | currency}}원</span></li>
            <li><em>보험환급금</em><span>{{String( subsc.payments.refund_data.insurance_refund) | currency}}원</span></li>
          </template>
          
          <li><em>총 환불금액</em><span>{{String(subsc.payments.price_refund) | currency}}원</span></li>
        </template>
      </ul>

      <!-- <a class="cardview" href="#">신용카드 전표</a> -->
    </div>

    <div class="titWrap" v-if="(typeof subsc.options.is_escalation != 'undefinde' && subsc.options.is_escalation)">
      <h3 class="conTit1">
        이관 정보
      </h3>
    </div>

    <div class="infoTable02" v-if="
      (typeof subsc.options.is_escalation != 'undefinde' && subsc.options.is_escalation) &&
      (typeof subsc.options.escalation != 'undefinde')
    ">
      <ul>
        <li><em>변경 전 고개</em><span>{{subsc.options.escalation.name}}</span></li>
        <li><em>변경 후 고객</em><span>{{subsc.user.name}}</span></li>
        <li><em>차대번호</em><span>{{subsc.vehicle.num_id}}</span></li>
        <li><em>차량번호</em><span>{{subsc.vehicle.num_reg}}</span></li>
        <li>
          <em>서비스 기간</em>
          <span>{{getDateFormat(subsc.date_start)}}<br>~ {{getDateFormat(subsc.date_stop)}}</span>
        </li>
        <li><em>양도일</em><span>{{ getDateFormat(subsc.options.escalation.date) }}</span></li>
      </ul>

      <!-- <a class="cardview" href="#">신용카드 전표</a> -->
    </div>


    <ul class="listDot mgt2">
      <li>{{$store.state.msg_}}</li>
    </ul>

  </div>

  <!-- 에러 popup -->
  <popup-alert v-if="alertActivate" title="알림" @close="closeAlert">
    {{alertMsg}}
  </popup-alert>

</content-div>
</template>


<script>
  import axios from "axios";
  import {api} from "@/api";
  import Format from "../../../helpers/Format.js";
  import Const from "../../../helpers/Const.js";
  import PopupAlert from '@/components/Popup/PopupAlert.vue';

  export default {
    components: {
      PopupAlert,
    },
    computed: {
      promoCodePrice() {
        return this.subsc.payments.promo_code.price;
      },
      promoPrice() {
        const pkgPrice = this.subsc.payments.price_pkg;
        const promoDiscount = this.subsc.payments.promo.price;
        return pkgPrice - promoDiscount;
      },
    },

    created() {
      this.getSubsc();
    },

    data() {
      return {
        onload: false,
        SUBSC_STATE: Const.SUBSC_STATE,
        OVERLAP_DISABLE: Const.PROMO_TYPE_OVERLAP_DISABLE,
        subsc: [],
        alertActivate: false,
      };
    },

    filters: Format,

    methods: {

      closeAlert(){
        this.alertActivate = false;
        this.$router.push('/');
      },

      getSubsc() {
        this.$store.commit('setBtnLoading', true);
        const subscId = this.$route.params.subsc_id;
        axios.get(`${api.subscs}/${subscId}`)
          .then(({data}) => {
            this.subsc = data.data;
            this.onload = true;
          })
          .catch((error) => {
            if(error.response.status == 401) {
              this.$store.commit('setPopup401', true);
            } else {
              this.alertMsg = this.errorMsg(error);
              this.alertActivate = true;
            }
          });
      },


    }
  };
</script>
